export class Alert {
  alertType = "error";
  showAlert = false;
  alertDuration = 0;
  message = "";
}
